export default __webpack_public_path__ + "static/media/IndiaStartup.88fddd77.png";